import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { ShopOrderBomTreeView } from "src/components/views/erp/production/shopOrderBom/ShopOrderBomTreeView.tsx";
import i18n from "i18next";
import { DocumentsOfObjectsDataGrid } from "src/components/views/documents/objectDocuments/DocumentsOfObjectsDataGrid.tsx";
import { useState } from "react";
import { DocumentConnectionView } from "src/api/generated/postgres/db/types/documents/tables/documentConnectionView.ts";
import { PartRevisionBomTreeItemModel } from "src/components/views/erp/parts/treeViews/treeItemMapping.ts";
import { DocumentPreviewView } from "src/components/views/documents/preview/DocumentPreviewView.tsx";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";

export interface ShopOrderBomTreeContainerProps {
	shopOrderId: number;
}

export const ShopOrderBomTreeContainer = ({ shopOrderId }: ShopOrderBomTreeContainerProps) => {
	const { tenantConfig } = useTenantCustomizations();
	const [selectedTreeItem, setSelectedTreeItem] = useState<PartRevisionBomTreeItemModel | null>(null);
	const selectedCatalogPartRevisionId =
		selectedTreeItem?.type === "part" ? selectedTreeItem?.activeCatalogPartRevisionId
		: selectedTreeItem?.type === "revision" ? selectedTreeItem?.catalogPartRevisionId
		: null;

	const [selectedDocument, setSelectedDocument] = useState<DocumentConnectionView | undefined>(undefined);
	const treeView = <ShopOrderBomTreeView shopOrderId={shopOrderId} onSelectionChanged={setSelectedTreeItem} />;

	if (!tenantConfig.documentsEnabled) {
		return treeView;
	}

	return (
		<AavoMosaic
			layout={{
				type: "row",
				first: {
					type: "column",
					first: {
						type: "panel",
						title: i18n.t("bom"),
						content: treeView,
					},
					second: {
						type: "tabs",
						items: [
							{
								type: "panel",
								title: i18n.t("revision_documents"),
								content:
									selectedCatalogPartRevisionId == null ?
										<CenteredTypography>{i18n.t("select_bom_line")}</CenteredTypography>
									:	<DocumentsOfObjectsDataGrid
											key={selectedCatalogPartRevisionId}
											onSelectionChanged={(value) => setSelectedDocument(value[0])}
											editable={false}
											selectMainDocumentOnLoad
											objectRefs={[
												{
													objectType: "CATALOG_PART_REVISION",
													objectId: selectedCatalogPartRevisionId,
												},
											]}
										/>,
							},
							{
								type: "panel",
								title: i18n.t("part_documents"),
								content:
									selectedTreeItem == null ?
										<CenteredTypography>{i18n.t("select_bom_line")}</CenteredTypography>
									:	<DocumentsOfObjectsDataGrid
											key={selectedTreeItem.id}
											onSelectionChanged={(value) => setSelectedDocument(value[0])}
											editable={false}
											selectMainDocumentOnLoad
											objectRefs={[
												{
													objectType: "PART",
													objectId: selectedTreeItem.partId,
												},
											]}
										/>,
							},
						],
					},
				},
				second: {
					type: "panel",
					title: i18n.t("preview"),
					content:
						selectedDocument == null ?
							<CenteredTypography>{i18n.t("select_document")}</CenteredTypography>
						:	<DocumentPreviewView
								key={selectedDocument.documentId}
								documentId={selectedDocument.documentId}
							/>,
				},
			}}
		/>
	);
};
